import { supabase } from "../lib/supabase";

export async function updateProject(projectId, workspaceId, patch) {
  const { data, error } = await supabase
    .from("projects")
    .update(patch)
    .eq("id", projectId)
    .eq("workspace_id", workspaceId)
    .select()
    .single();

  if (error) throw error;

  return data;
}